import { useMemo } from 'react'
import { useQueryState } from 'nuqs'
import {
  type OfferRecommendationFragment,
  type ProductOfferFragment,
  useProductRecommendationsQuery,
} from '@/services/graphql/generated'
import { useShopSession } from '@/services/shopSession/ShopSessionContext'

export const OFFER_TO_EDIT_QUERY_PARAM = 'edit'

export type OfferToEdit =
  | { isInCart: true; offer: ProductOfferFragment }
  | { isInCart: false; offer: OfferRecommendationFragment }

export const useOfferToEdit = () => {
  const { shopSession } = useShopSession()
  const [cartEntryId] = useQueryState(OFFER_TO_EDIT_QUERY_PARAM)

  const { data: recommendationsData } = useProductRecommendationsQuery({
    variables: shopSession?.id ? { shopSessionId: shopSession.id } : undefined,
    skip: shopSession?.id == null || cartEntryId == null,
  })

  const cartItems = shopSession?.cart.items

  return useMemo((): OfferToEdit | undefined => {
    if (!cartEntryId) return undefined

    const cartOffer = cartItems?.find((item) => item.productOffer.id === cartEntryId)?.productOffer
    if (cartOffer) return { isInCart: true, offer: cartOffer }

    const recommendation = recommendationsData?.shopSession.recommendations.find((rec) => rec.offer?.id === cartEntryId)
    if (recommendation?.offer) return { isInCart: false, offer: recommendation.offer }

    return undefined
  }, [cartItems, cartEntryId, recommendationsData])
}
